import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import propTypes from 'prop-types';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateRangePicker from '@mui/lab/DateRangePicker';
import Box from '@mui/material/Box';
import { StyledButton } from '../../../../Components/Generics.styled';
import { useAdvertisers } from '../../../../Contexts/AdvertisersContext';
import useRequest from '../../../../Hooks/useRequest';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const NavigationSection = styled.div`
    width: 150px;
    display: flex;
    justify-content: space-between;
`;

const EditAndDuplicateCampaignsModalContainer = styled.div`
    height: 600px;
    margin-bottom: 20px;
`;

const Title = styled.div`
    font-size: 30px;
    margin-bottom: 25px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
`;

const StyledSelect = styled(Select)`
    width: 100%;
    min-width: 300px;
    text-align: left;
`;

const FormContainer = styled.div`
    padding-top: 20px;
    padding-bottom: 20px;

    overflow: auto;
    max-height: 500px;

    display: flex;
    flex-direction: column;
`;
const Row = styled.div`
    display: flex;
    justify-content: space-evenly;
    margin-bottom: 30px;
`;

const StyledTextField = styled(TextField)`
    width: 100%;
    max-width: 300px;
`;

const StyledAutoCompleteContainer = styled.div`
    width: 100%;
    margin-left: 35px;
    margin-right: 33px;
`;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    width: 1100,
    padding: 23,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const DatePickerContainer = styled.div`
    width: 100%;
    max-width: 300px;
    height: 70px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;

    .MuiOutlinedInput-root {
        background-color: #fafbf7;
    }
`;

const EditAndDuplicateCampaignsModal = (props) => {
    const {
        modalIsOpen,
        setModalIsOpen,
        campaignData,
        setCampaignData,
        date,
        setDate,
        postData,
        handlePostDuplicate,
    } = props;

    const {
        headline,
        headline2,
        headline3,
        headline4,
        headline5,
        headline6,
        description,
        description2,
        description3,
        description4,
        websiteURL,
        googleCampaignKeywords,
        budget,
        campaignName,
        campaignType,
        googleCampaignLocations,
        pontiacCampaignLocations,
        pontiacCreative,
        startDate,
        endDate,
    } = { ...campaignData };

    const [keywordVals, setKeywordVals] = useState([]);
    const [keywordsTooLong, setKeywordsTooLong] = useState(false);
    const { advertisers, setCurrentAdvertiser, currentAdvertiser, advertiserMetaData } =
        useAdvertisers();
    const aWeekFromToday = new Date(Date.now() + 3600 * 1000 * 168);
    const googleMinBudget =
        advertiserMetaData?.selectedAdvertiserPlanData?.googleCampaignMinimumBudget;
    const pontiacMinBudget =
        advertiserMetaData?.selectedAdvertiserPlanData?.pontiacCampaignMinimumBudget;
    const [campaignTypeCategories, setCampaignTypeCategories] = useState([]);

    const isGoogle = campaignData?.campaignTypeId === 1;
    const isProgrammatic = campaignData?.campaignTypeId === 26;
    const isMobile = campaignData?.campaignTypeId === 2;

    const headlineSame =
        headline === headline2 ||
        headline === headline3 ||
        headline === headline4 ||
        headline === headline5 ||
        headline === headline6;

    const headline2Same =
        headline2 === headline ||
        headline2 === headline3 ||
        headline2 === headline4 ||
        headline2 === headline5 ||
        headline2 === headline6;

    const headline3Same =
        headline3 === headline ||
        headline3 === headline2 ||
        headline3 === headline4 ||
        headline3 === headline5 ||
        headline3 === headline6;

    const headline4Same =
        headline4 === headline ||
        headline4 === headline2 ||
        headline4 === headline3 ||
        headline4 === headline5 ||
        headline4 === headline6;

    const headline5Same =
        headline5 === headline ||
        headline5 === headline2 ||
        headline5 === headline3 ||
        headline5 === headline4 ||
        headline5 === headline6;

    const headline6Same =
        headline6 === headline ||
        headline6 === headline2 ||
        headline6 === headline3 ||
        headline6 === headline4 ||
        headline6 === headline5;

    const descriptionSame =
        description === description2 ||
        description === description3 ||
        description === description4;

    const description2Same =
        description2 === description3 ||
        description2 === description4 ||
        description2 === description;

    const description3Same =
        description3 === description4 ||
        description3 === description ||
        description3 === description2;

    const description4Same =
        description4 === description ||
        description4 === description2 ||
        description4 === description3;

    const nextButtonIsDisabled =
        (isMobile &&
            (campaignName === '' ||
                headline === '' ||
                headline?.length > 30 ||
                description === '' ||
                description?.length > 90 ||
                description2 === '' ||
                description2?.length > 30 ||
                brand === '')) ||
        (isGoogle &&
            (campaignName === '' ||
                campaignName.length > 25 ||
                headline === '' ||
                headline?.length < 3 ||
                headline?.length > 30 ||
                headlineSame ||
                headline2 === '' ||
                headline2?.length < 3 ||
                headline2?.length > 30 ||
                headline2Same ||
                headline3 === '' ||
                headline3?.length < 3 ||
                headline3?.length > 30 ||
                headline3Same ||
                headline4?.length > 30 ||
                (headline4Same && headline4 !== '') ||
                headline5?.length > 30 ||
                (headline5Same && headline5 !== '') ||
                headline6?.length > 30 ||
                (headline6Same && headline6 !== '') ||
                description === '' ||
                description?.length > 90 ||
                description?.length < 3 ||
                descriptionSame ||
                description2 === '' ||
                description2?.length > 90 ||
                description2?.length < 3 ||
                description2Same ||
                description3?.length > 90 ||
                (description3 !== '' && description3Same) ||
                description4?.length > 90 ||
                googleCampaignKeywords?.length < 1 ||
                keywordsTooLong ||
                (description4 !== '' && description4Same))) ||
        startDate === '' ||
        endDate === '' ||
        budget < googleMinBudget ||
        (isProgrammatic &&
            (campaignName === '' ||
                campaignName?.length > 25 ||
                startDate === '' ||
                endDate === '' ||
                budget < pontiacMinBudget));

    const { advertiserList } = { ...advertisers };

    useEffect(() => {
        googleCampaignKeywords?.map((item) => {
            if (item.length > 25) {
                setKeywordsTooLong(true);
            } else {
                setKeywordsTooLong(false);
            }
        });
    }, [googleCampaignKeywords]);

    const handleAdvertiserChange = (e, value) => {
        setCurrentAdvertiser(value);
        setCampaignData({
            ...campaignData,
            advertiserCompanyName: value.companyName,
            advertiserId: value.advertiserId,
        });
    };

    //api calls
    const { data: campaignTypeData } = useRequest('/getAllCampaignTypes');

    useEffect(() => {
        if (campaignData?.campaignTypeId !== 0) {
            const selectedCampaignType = campaignTypeData?.find((item) => {
                if (item?.campaignTypeId === campaignData?.campaignTypeId) {
                    return true;
                }
                return false;
            });
            setCampaignTypeCategories(selectedCampaignType?.campaignTypeCategories);

            campaignTypeCategories?.map((item) => {
                if (item.campaignTypeCategoryId === campaignData?.campaignTypeCategoryId) {
                    setCampaignData({
                        ...campaignData,
                        categoryName: item.categoryName,
                    });
                }
                return null;
            });
        }
    }, [campaignData.campaignTypeCategoryId]);

    const handleKeywords = (e) => {
        setKeywordVals([e.target.value]);
    };

    const handleClose = () => {
        setModalIsOpen(false);
    };
    const handleDateChange = (newValue) => {
        setDate(newValue);
    };

    const dateIsEmpty = date[0] === null || date[1] === null;

    const handleCampaignDate = () => {
        if (!dateIsEmpty) {
            setCampaignData({
                ...campaignData,
                startDate: date[0].toISOString(),
                endDate: date[1].toISOString(),
            });
        }
    };

    useEffect(() => {
        handleCampaignDate();
    }, [date]);

    const googleForm = (
        <FormContainer>
            <Row>
                <StyledTextField
                    id="campaignName"
                    label="Campaign Name"
                    defaultValue={campaignName}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            campaignName: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={
                        campaignName === '' || campaignName?.length > 25 || campaignName?.length < 3
                    }
                    helperText={
                        campaignName?.length > 25 || campaignName?.length < 3
                            ? 'Must be greater than 3 characters and less than 25'
                            : ''
                    }
                />
                <StyledTextField
                    id="campaignType"
                    label="Campaign Type"
                    defaultValue={campaignType}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            campaignType: e.target.value,
                        })
                    }
                    variant="outlined"
                    disabled
                />
                <FormControl variant="outlined">
                    <InputLabel id="select-category-dropdown">Select Category</InputLabel>
                    <StyledSelect
                        labelId="select-category-dropdown"
                        id="select-category-dropdown-outlined"
                        value={campaignData.campaignTypeCategoryId}
                        onChange={(e) =>
                            setCampaignData({
                                ...campaignData,
                                campaignTypeCategoryId: e.target.value,
                            })
                        }
                        label="Select Category"
                    >
                        {campaignTypeCategories?.map((item, idx) => {
                            return (
                                <MenuItem key={idx} value={item.campaignTypeCategoryId}>
                                    {item.categoryName}
                                </MenuItem>
                            );
                        })}
                    </StyledSelect>
                </FormControl>
            </Row>
            <Row>
                <StyledTextField
                    id="headline"
                    label="Headline"
                    defaultValue={headline}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            headline: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={
                        headline === '' ||
                        headline?.length > 30 ||
                        headline?.length < 3 ||
                        headlineSame
                    }
                    helperText={
                        headline?.length > 30 || headline?.length < 3 || headlineSame
                            ? 'Must be unique, greater than 3 characters and less than 30'
                            : ''
                    }
                />
                <StyledTextField
                    id="headline2"
                    label="Headline 2"
                    defaultValue={headline2}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            headline2: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={
                        headline2 === '' ||
                        headline2?.length > 30 ||
                        headline2?.length < 3 ||
                        headline2Same
                    }
                    helperText={
                        headline2?.length > 30 || headline2?.length < 3 || headline2Same
                            ? 'Must be unique, greater than 3 characters and less than 30 characters.'
                            : ''
                    }
                />
                <StyledTextField
                    id="headline3"
                    label="Headline 3"
                    defaultValue={headline3}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            headline3: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={
                        headline3 === '' ||
                        headline3?.length > 30 ||
                        headline3?.length < 3 ||
                        headline3Same
                    }
                    helperText={
                        headline3?.length > 30 || headline3?.length < 3 || headline3Same
                            ? 'Must be unique, greater than 3 characters and less than 30 characters'
                            : ''
                    }
                />
            </Row>
            <Row>
                <StyledTextField
                    id="headline4"
                    label="Headline 4"
                    defaultValue={headline4}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            headline4: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={headline4?.length > 30 || (headline4 !== '' && headline4Same)}
                    helperText={
                        headline4?.length > 30 || (headline4 !== '' && headline4Same)
                            ? 'Must be unique and less than 30 characters'
                            : ''
                    }
                />
                <StyledTextField
                    id="headline5"
                    label="Headline 5"
                    defaultValue={headline5}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            headline5: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={headline5?.length > 30 || (headline5 !== '' && headline5Same)}
                    helperText={
                        headline5?.length > 30 || (headline5 !== '' && headline5Same)
                            ? 'Must be unique and less than 30 characters'
                            : ''
                    }
                />
                <StyledTextField
                    id="headline6"
                    label="Headline 6"
                    defaultValue={headline6}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            headline6: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={headline6?.length > 30 || (headline6 !== '' && headline6Same)}
                    helperText={
                        headline6?.length > 30 || (headline6 !== '' && headline6Same)
                            ? 'Must be unique and less than 30 characters'
                            : ''
                    }
                />
            </Row>
            <Row>
                <StyledTextField
                    id="description"
                    label="description"
                    defaultValue={description}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            description: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={
                        description === '' ||
                        description?.length > 90 ||
                        description?.length < 3 ||
                        descriptionSame
                    }
                    helperText={
                        description?.length > 90 || description?.length < 3 || descriptionSame
                            ? 'Must be unique and greater than 3 characters and less than 90'
                            : ''
                    }
                />
                <StyledTextField
                    id="description2"
                    label="description 2"
                    defaultValue={description2}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            description2: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={
                        description2 === '' ||
                        description2?.length > 90 ||
                        description2?.length < 3 ||
                        description2Same
                    }
                    helperText={
                        description2?.length > 90 || description2?.length < 3 || description2Same
                            ? 'Must be greater than 3 characters and less than 90 characters'
                            : ''
                    }
                />
                <StyledTextField
                    id="description3"
                    label="description 3"
                    defaultValue={description3}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            description3: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={
                        description3 === '' ||
                        description3?.length > 90 ||
                        description3?.length < 3 ||
                        description3Same
                    }
                    helperText={
                        description3?.length > 90 || description3?.length < 3 || description3Same
                            ? 'Must be greater than 3 characters and less than 90 characters'
                            : ''
                    }
                />
            </Row>
            <Row>
                <StyledTextField
                    id="description4"
                    label="description 4"
                    defaultValue={description4}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            description4: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={
                        description4 === '' ||
                        description4?.length > 90 ||
                        description4?.length < 4 ||
                        description4Same
                    }
                    helperText={
                        description4?.length > 90 || description4?.length < 4 || description4Same
                            ? 'Must be greater than 3 characters and less than 90 characters'
                            : ''
                    }
                />
                <StyledTextField
                    id="website-url"
                    label="Website URL"
                    defaultValue={websiteURL}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            websiteURL: e.target.value,
                        })
                    }
                    variant="outlined"
                />

                <StyledTextField
                    id="budget"
                    label="Budget"
                    defaultValue={budget}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            budget: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={campaignData.budget === '' || (isGoogle && budget < googleMinBudget)}
                    helperText={
                        isGoogle && campaignData.budget < googleMinBudget
                            ? `Minimum budget for Davie is $${googleMinBudget} per month`
                            : ''
                    }
                />
            </Row>

            <Row>
                {' '}
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={advertiserList || []}
                    disabled
                    value={currentAdvertiser}
                    getOptionLabel={(option) => `${option.companyName}`}
                    onChange={(e, value) => handleAdvertiserChange(e, value)}
                    sx={{ width: 640 }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Select Advertiser"
                            label="Select Advertiser"
                        />
                    )}
                />
                <DatePickerContainer>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DateRangePicker
                            startText="Start Date"
                            endText="End Date"
                            value={date}
                            minDate={aWeekFromToday}
                            onChange={(newValue) => {
                                handleDateChange(newValue);
                            }}
                            renderInput={(startProps, endProps) => (
                                <>
                                    <TextField
                                        variant="outlined"
                                        {...startProps}
                                        error={dateIsEmpty}
                                        helperText={
                                            dateIsEmpty ? 'Start date can not be empty.' : null
                                        }
                                    />
                                    <Box sx={{ mx: 2 }}> to </Box>
                                    <TextField
                                        error={dateIsEmpty}
                                        helperText={
                                            dateIsEmpty ? 'End date can not be empty.' : null
                                        }
                                        variant="outlined"
                                        {...endProps}
                                    />
                                </>
                            )}
                        />
                    </LocalizationProvider>
                </DatePickerContainer>
            </Row>

            <Row>
                <StyledAutoCompleteContainer>
                    <Autocomplete
                        multiple
                        disabled
                        id="locations"
                        options={[]}
                        value={googleCampaignLocations || []}
                        getOptionLabel={(option) =>
                            `${option.canonicalName}, (Reach: ${option.reach})`
                        }
                        onChange={(e, value) =>
                            setCampaignData({
                                ...campaignData,
                                googleCampaignLocations: value,
                            })
                        }
                        renderInput={(params) => (
                            <StyledTextField
                                style={{ maxWidth: '100%' }}
                                onChange={(e) => e}
                                disabled
                                variant="outlined"
                                {...params}
                                label="Locations"
                                placeholder="Locations"
                            />
                        )}
                    />
                </StyledAutoCompleteContainer>
            </Row>

            <Row>
                <StyledAutoCompleteContainer>
                    <Autocomplete
                        multiple
                        id="keywords"
                        options={keywordVals}
                        value={googleCampaignKeywords || []}
                        getOptionLabel={(option) => option}
                        onChange={(e, value) =>
                            setCampaignData({
                                ...campaignData,
                                googleCampaignKeywords: value,
                            })
                        }
                        renderInput={(params) => (
                            <StyledTextField
                                style={{ maxWidth: '100%' }}
                                onChange={(e) => handleKeywords(e)}
                                variant="outlined"
                                {...params}
                                label="Keywords"
                                placeholder="Keywords"
                                error={googleCampaignKeywords?.length < 1 || keywordsTooLong}
                                helperText={
                                    keywordsTooLong || googleCampaignKeywords?.length < 1
                                        ? 'You must select at least one keyword, and keywords must be below 25 characters.'
                                        : ''
                                }
                            />
                        )}
                    />
                </StyledAutoCompleteContainer>
            </Row>
        </FormContainer>
    );

    const programmaticForm = (
        <FormContainer>
            <Row>
                <StyledTextField
                    id="campaignName"
                    label="Campaign Name"
                    defaultValue={campaignName}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            campaignName: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={
                        campaignName === '' || campaignName?.length > 25 || campaignName?.length < 3
                    }
                    helperText={
                        campaignName?.length > 25 || campaignName?.length < 3
                            ? 'Must be greater than 3 characters and less than 25'
                            : ''
                    }
                />
                <StyledTextField
                    id="campaignType"
                    label="Campaign Type"
                    defaultValue={campaignType}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            campaignType: e.target.value,
                        })
                    }
                    variant="outlined"
                    disabled
                />
                <FormControl variant="outlined">
                    <InputLabel id="select-category-dropdown">Select Category</InputLabel>
                    <StyledSelect
                        labelId="select-category-dropdown"
                        id="select-category-dropdown-outlined"
                        value={campaignData.campaignTypeCategoryId}
                        onChange={(e) =>
                            setCampaignData({
                                ...campaignData,
                                campaignTypeCategoryId: e.target.value,
                            })
                        }
                        label="Select Category"
                    >
                        {campaignTypeCategories?.map((item, idx) => {
                            return (
                                <MenuItem key={idx} value={item.campaignTypeCategoryId}>
                                    {item.categoryName}
                                </MenuItem>
                            );
                        })}
                    </StyledSelect>
                </FormControl>
            </Row>

            <Row>
                <StyledTextField
                    id="file-url"
                    label="File URL"
                    defaultValue={pontiacCreative?.azureFileURL}
                    variant="outlined"
                    disabled
                />
                <StyledTextField
                    id="website-url"
                    label="Website URL"
                    defaultValue={websiteURL}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            websiteURL: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={websiteURL === ''}
                    helperText={websiteURL === '' ? 'Must contain a valid website URL.' : ''}
                />

                <StyledTextField
                    id="budget"
                    label="Budget"
                    defaultValue={budget}
                    onChange={(e) =>
                        setCampaignData({
                            ...campaignData,
                            budget: e.target.value,
                        })
                    }
                    variant="outlined"
                    error={campaignData.budget === '' || campaignData.budget < pontiacMinBudget}
                    helperText={
                        campaignData.budget < pontiacMinBudget
                            ? `Minimum budget for Davie is $${pontiacMinBudget} per month`
                            : ''
                    }
                />
            </Row>

            <Row>
                {' '}
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={advertiserList || []}
                    disabled
                    value={currentAdvertiser}
                    getOptionLabel={(option) => `${option.companyName}`}
                    onChange={(e, value) => handleAdvertiserChange(e, value)}
                    sx={{ width: 640 }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Select Advertiser"
                            label="Select Advertiser"
                        />
                    )}
                />
                <DatePickerContainer>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DateRangePicker
                            startText="Start Date"
                            endText="End Date"
                            value={date}
                            minDate={aWeekFromToday}
                            onChange={(newValue) => {
                                handleDateChange(newValue);
                            }}
                            renderInput={(startProps, endProps) => (
                                <>
                                    <TextField
                                        variant="outlined"
                                        {...startProps}
                                        error={dateIsEmpty}
                                        helperText={
                                            dateIsEmpty ? 'Start date can not be empty.' : null
                                        }
                                    />
                                    <Box sx={{ mx: 2 }}> to </Box>
                                    <TextField
                                        variant="outlined"
                                        {...endProps}
                                        error={dateIsEmpty}
                                        helperText={
                                            dateIsEmpty ? 'End date can not be empty.' : null
                                        }
                                    />
                                </>
                            )}
                        />
                    </LocalizationProvider>
                </DatePickerContainer>
            </Row>

            <Row>
                <StyledAutoCompleteContainer>
                    <Autocomplete
                        multiple
                        disabled
                        id="locations"
                        options={[]}
                        value={pontiacCampaignLocations || []}
                        getOptionLabel={(option) =>
                            `${option.name}, (Zip: ${option.zipCodes
                                .map((item) => item)
                                .join(', ')})`
                        }
                        onChange={(e, value) =>
                            setCampaignData({
                                ...campaignData,
                                pontiacCampaignLocations: value,
                            })
                        }
                        renderInput={(params) => (
                            <StyledTextField
                                style={{ maxWidth: '100%' }}
                                onChange={(e) => e}
                                disabled
                                variant="outlined"
                                {...params}
                                label="Locations"
                                placeholder="Locations"
                            />
                        )}
                    />
                </StyledAutoCompleteContainer>
            </Row>
        </FormContainer>
    );

    const body = (
        <div style={style}>
            <EditAndDuplicateCampaignsModalContainer>
                <Title>Duplicate Campaign</Title>
                {isGoogle ? googleForm : programmaticForm}
            </EditAndDuplicateCampaignsModalContainer>
            <NavigationSection>
                <StyledButton onClick={() => handleClose()} variant="contained" color="primary">
                    Cancel
                </StyledButton>
                <StyledButton
                    disabled={nextButtonIsDisabled}
                    onClick={() => handlePostDuplicate()}
                    variant="contained"
                    color="primary"
                >
                    {postData.isLoading ? (
                        <CircularProgress
                            style={{ height: '20px', width: '20px', color: 'white' }}
                            color="primary"
                        />
                    ) : (
                        'Save'
                    )}
                </StyledButton>
            </NavigationSection>
            {
                <div
                    style={{
                        marginTop: '16px',
                        marginLeft: '300px',
                        marginBottom: '8px',
                        color: postData.error ? 'red' : 'green',
                        fontSize: '16px',
                    }}
                >
                    {postData.message && postData.message.length >= 1
                        ? postData.message.map((item, idx) => <div key={idx}>{item}</div>)
                        : postData.message}
                </div>
            }
        </div>
    );

    return (
        <div>
            <Modal
                open={modalIsOpen}
                onClose={() => handleClose()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
};

EditAndDuplicateCampaignsModal.propTypes = {
    modalIsOpen: propTypes.bool,
    setModalIsOpen: propTypes.func,
    setCampaignData: propTypes.func,
    campaignData: propTypes.shape({
        budget: propTypes.number,
        campaignTypeName: propTypes.string,
        campaignType: propTypes.string,
        campaignTypeCategoryId: propTypes.number,
        campaignTypeId: propTypes.number,
    }),
    date: propTypes.array,
    setDate: propTypes.func,
    handlePostDuplicate: propTypes.func,
    postData: propTypes.shape({
        isLoading: propTypes.bool,
        success: propTypes.bool,
        error: propTypes.bool,
        message: propTypes.array,
    }),
};

EditAndDuplicateCampaignsModal.defaultProps = {
    modalIsOpen: false,
    setModalIsOpen: () => {},
    date: [null, null],
    handlePostDuplicate: () => {},
    postData: { isLoading: false },
    setCampaignData: () => {},
    campaignData: {},
};
export default EditAndDuplicateCampaignsModal;
